import { blogIndex } from '../data/blogIndex.js';
import { hizliTuketilenIliskiler } from '../data/blog-posts/hizli-tuketilen-iliskiler.js';
import { oyunTerapisiNedir } from '../data/blog-posts/oyun-terapisi-nedir.js';
import { okulBasarisiVeCocukPsikolojisi } from '../data/blog-posts/okul-basarisi-ve-cocuk-psikolojisi.js';
import { cocuklardaDikkatEksikligiVeHiperaktiviteBozuklugu } from '../data/blog-posts/cocuklarda-dikkat-eksikligi-ve-hiperaktivite-bozuklugu-dehb.js';
import { okulaUyumSurecindeCocuklariDesteklemek } from '../data/blog-posts/okula-uyum-surecinde-cocuklari-desteklemek.js';
import { terapiSureci } from '../data/blog-posts/terapi-sureci.js';
import { terapiTurleriNelerdir } from '../data/blog-posts/terapi-turleri-nelerdir.js';
import { sosyalMedyadaIdealizeEdilmisHayatlar } from '../data/blog-posts/sosyal-medyada-idealize-edilmis-hayatlar.js';

// Static blog posts mapping
const blogPosts = {
  "sosyal-medyada-idealize-edilmis-hayatlar": sosyalMedyadaIdealizeEdilmisHayatlar,
  "terapi-turleri-nelerdir": terapiTurleriNelerdir,
  "terapi-sureci": terapiSureci,
  "hizli-tuketilen-iliskiler": hizliTuketilenIliskiler,
  "oyun-terapisi-nedir": oyunTerapisiNedir,
  "okul-basarisi-ve-cocuk-psikolojisi": okulBasarisiVeCocukPsikolojisi,
  "cocuklarda-dikkat-eksikligi-ve-hiperaktivite-bozuklugu-dehb": cocuklardaDikkatEksikligiVeHiperaktiviteBozuklugu,
  "okula-uyum-surecinde-cocuklari-desteklemek": okulaUyumSurecindeCocuklariDesteklemek,
};

export const useBlogContent = () => {
  const getAllPosts = () => {
    // Sadece temel bilgileri döndür (blog listesi için)
    return Object.values(blogIndex);
  };

  const getPostBySlug = (slug) => {
    // Artık sync olarak çalışır - flicker yok
    return blogPosts[slug] || null;
  };

  return {
    getAllPosts,
    getPostBySlug
  };
};
